import * as Common from "../../commons/common"

export class SumupListCondition {
  id: string = ""
  month: string = ""
  name: string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
}

export class SumupGroup {
  id: number
  exec_date: string
  name: string
  saiten_completed: boolean
  is_approved: boolean
  curriculum_ids: number[]
  created_at: string
  isSelected: boolean = false

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.exec_date = sumupGroup.exec_date;
    this.saiten_completed = sumupGroup.saiten_completed;
    this.is_approved = sumupGroup.is_approved;
    this.created_at = sumupGroup.created_at;
    this.name = sumupGroup.name;
    this.curriculum_ids = sumupGroup.curriculum_ids;
  }
}